import React from "react";
import style from "./index.module.scss";
// import styled from "styled-components";
// import { showDialog } from "./dialog";
import { showDialog } from "../../../vop_index_banner/components/App/dialog";

const App = (props) => {
  const { bgImageUrl, list } = props;
  return (
    <div className={`${style.app} ${style.appContaner}`}>
      <img className={style.bgImg} src={bgImageUrl} alt="bgimg" />
      <div className={style.mask}></div>
      <div className={style.content}>
        <div className={style.steps}>
          <div className={style.stepItems}>
            {list &&
              list.map((d, i) => (
                <div className={style.stepItem} key={i}>
                  <img className={style.stepItemIcon} src={d.icon} alt="" />
                  <p className={style.stepItemText}>{d.text}</p>
                </div>
              ))}
          </div>
          <img
            className={style.timeline}
            src="https://img12.360buyimg.com/imagetools/jfs/t1/135897/3/16241/1500/5fb32e9bE97bf0961/c6ac0dcb2afb7f7d.png"
            alt=""
          />
        </div>
        <div className={style.operation}>
          <span
            className={style.btnCooperate}
            onClick={() => showDialog()}
            clstag="pageclick|keycount|VopOpenIndex_1602911919488|6"
          >
            我要合作
          </span>
        </div>
      </div>
    </div>
  );
};

export default App;
